<template>
    <div class="cards">
        <div v-if="total === 0 && !preview" class="container">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex justify-content-center py-4 mb-3">
                        <SearchEmptyState />
                    </div>
                </div>
            </div>
        </div>
        <div v-if="total !== 0 && preview" class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="p4n c3 mt-5 mb-3 ml-2">Matching campaigns</h4>
                </div>
            </div>
        </div>
        <div id="campaigns-grid" v-if="searchResults.length" class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6 col-6 "
                    :class="{'col-lg-4 col-12': $route.path === '/advanced-search'}"
                    v-for="(card, index) in searchResults" :key="`card-${index}`"
                    style="margin-bottom: 32px">
                        <Card :card="card" id="" list="real" :matching-campaign="$route.name === 'Campaign Page'"/>   
                </div>
            </div>
            <Loader v-if="searchLoading" />
            <button 
                v-if="total > searchResults.length && !preview" 
                class="phiolet_button mx-auto d-block mb-5"
                id="load-more-cards-homepage"
                style="height: 48px; padding: 0 30px" @click="loadMore">
                    Load More
            </button>
        </div>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import Card from '../Card'
    import Loader from '../Icons/Loader'
    import {
        SearchEmptyState
    } from '../Icons'

    export default {
        name: 'AdvancedSearchResult',
        components: {
            Card,
            SearchEmptyState,
            Loader,
        },
        props: [
            'preview',
        ],
        computed: {
            ...mapState([
                'searchResults',
                'searchLoading',
                'total'
            ])
        },
        methods: {
            loadMore: function () {
                const page = parseInt(this.$route.query.page) || 1
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        page: page + 1,
                    }
                }).catch(() => {})
            }
        }
    }
</script>